import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useLanguage();
  const items = t("faq.items") || [];

  return (
    <section id="faq" data-testid="faq-section" className="py-20 sm:py-32 lg:py-40 bg-[#0d0c0b]">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-20">
          <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">{t("faq.label")}</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#f4ede0] mt-4 sm:mt-6 leading-tight">
            {t("faq.title1")} <span className="italic copper-text">{t("faq.title2")}</span>{t("faq.title3")}
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {items.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-b border-[#2a2422]" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display text-xl lg:text-2xl text-[#f4ede0] hover:text-[#d89557] hover:no-underline py-7 text-left">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#cbc1ad] text-base leading-relaxed pb-7 max-w-3xl">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
